import { observable } from "mobx";

import { LSWidgetElement } from "@data-types/live-widget/LSwidgetElement";
import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import { LiveWidgetTypes } from "@data-types/live-widget/LiveWidgetTypes";
import { ProviderNameEnum } from "@gp/models";

export class LiveStreamWidget extends LSWidgetElement {
	@observable public message?: LSWidgetElement["message"];
	@observable public isStarted?: boolean | undefined;
	@observable public url: string | undefined;
	public provider;
	public isError: boolean = false;
	@observable public isUserInitiated: boolean = false;
	@observable public autoPlay: boolean = false;

	constructor(
		eventId: string,
		location: WidgetLocation,
		teamOneName: string,
		teamTwoName: string
	) {
		super();
		this.type = LiveWidgetTypes.LS;
		this.eventId = eventId;
		this.location = location;
		this.teamOneName = teamOneName;
		this.teamTwoName = teamTwoName;
		this.provider = ProviderNameEnum.LSports;
	}
}
